module.exports = __webpack_public_path__ + "static/media/dashboard-logo.0c0c7d4d.svg";